import { AnalyticsOptions } from 'owa-analytics';
import getMailAriaTenantTokens from 'owa-analytics/lib/utils/getMailAriaTenantTokens';

export default function(): AnalyticsOptions {
    return {
        ariaTenantTokens: getMailAriaTenantTokens(),
        flightControls: {
            client_event: {
                flight: 'an-sampled-client-event',
                rate: 5,
            },
            client_error: {
                flight: 'an-client-error',
            },
            client_verbose: {
                flight: 'an-client-verbose-wl',
                rate: 1,
            },
            client_network_request: {
                flight: 'an-client-network-request',
                rate: 2,
            },
        },
        verboseWhiteListEvents: ['AttachmentRefreshDownloadToken', 'TabViewActivateTab'],
    };
}
